import axios from "axios";
import { TOPICS } from "../data/constants";

const API = process.env.REACT_APP_BACKEND_URL || "";

export async function fetchTopicsMerged() {
  const r = await axios.get(`${API}/api/v1/topics`, { timeout: 8000 });
  if (!r.data?.items?.length) return null;
  const bySlug = Object.fromEntries(TOPICS.map((t) => [t.slug, t]));
  return r.data.items.map((it) => ({
    ...(bySlug[it.slug] || {}),
    slug: it.slug,
    title: it.title,
    subtitle: it.subtitle,
    image: bySlug[it.slug]?.image,
    tint: bySlug[it.slug]?.tint || ["#78716c", "#a8a29e"],
  }));
}

export async function fetchAdsForTopics() {
  const list = await Promise.all(
    TOPICS.map((t) =>
      axios
        .get(`${API}/api/v1/ads/next?slot=topic-${t.slug}`, { timeout: 8000 })
        .then((r) => ({ slug: t.slug, campaign: r.data?.campaign }))
        .catch(() => ({ slug: t.slug, campaign: null })),
    ),
  );
  const initial = {};
  const pool = [];
  const seen = new Set();
  list.forEach(({ slug, campaign }) => {
    if (campaign) {
      initial[slug] = campaign;
      if (!seen.has(campaign.id)) {
        pool.push(campaign);
        seen.add(campaign.id);
      }
    }
  });
  return { initial, pool };
}

export async function fetchNextAdForSlug(slug, excludeId) {
  const excludeParam = excludeId ? `&exclude=${excludeId}` : "";
  const r = await axios.get(
    `${API}/api/v1/ads/next?slot=topic-${slug}-${Date.now()}${excludeParam}`,
    { timeout: 8000 },
  );
  return r.data?.campaign || null;
}
